import * as THREE from 'three'
import Experience from "../../../Experience"
import vertexShader from './vertex.glsl'
import fragmentShader from './fragment.glsl'

export default class PlanetHighlights
{
  constructor()
  {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.debug = this.experience.debug
    this.time = this.experience.time

    const geometry = new THREE.PlaneGeometry(16, 8, 4, 4)
    this.material = new THREE.ShaderMaterial({
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      uniforms: {
        uTime: { value: 0 },
        uRadius: { value: 0.8 },    // 円のサイズ（0.0-1.0）
        uSoftness: { value: 2.0 },  // エッジの柔らかさ（1.0-5.0推奨）
        uTint: { value: new THREE.Color(1, 1, 1) } // 演出用の乗算色（白 = 無効果）
      },
      transparent: true,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
      side: THREE.DoubleSide,
    })


    this.mesh = new THREE.Mesh(geometry, this.material)
    // this.mesh.position.set(-6.3, -3.8, 12.2)
    // 10.3
    this.mesh.position.set(-5.6, -3.8, 14)
    this.mesh.rotation.set(0.2884, 1.0584, -0.5615)
    this.scene.add(this.mesh)
    this.setDebug()
  }

  update()
  {
    // 時間を更新してアニメーション効果を作る
    if (this.material.uniforms.uTime) {
      this.material.uniforms.uTime.value = this.time.elapsed * 0.001 // ミリ秒を秒に変換
    }
  }

  setDebug()
  {
    // デバッグGUIでリアルタイム調整（オプション）
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("PlateHighlights")
      this.debugFolder.add(this.mesh.position, 'x')
        .name("Position X").min(-20).max(30).step(0.1);
      this.debugFolder.add(this.mesh.position, 'y')
        .name("Position Y").min(-20).max(30).step(0.1);
      this.debugFolder.add(this.mesh.position, 'z')
        .name("Position Z").min(-20).max(30).step(0.1);

      this.debugFolder.add(this.mesh.rotation, 'x')
        .name("Rotation X").min(-Math.PI).max(Math.PI).step(0.01);
      this.debugFolder.add(this.mesh.rotation, 'y')
        .name("Rotation Y").min(-Math.PI).max(Math.PI).step(0.01);
      this.debugFolder.add(this.mesh.rotation, 'z')
        .name("Rotation Z").min(-Math.PI).max(Math.PI).step(0.01);

      this.debugFolder.add(this.material.uniforms.uRadius, 'value')
        .min(0.1).max(1.0).step(0.01).name('Circle Size')
      this.debugFolder.add(this.material.uniforms.uSoftness, 'value')
        .min(0.5).max(5.0).step(0.1).name('Edge Softness')

      this.debugFolder.close()
    }
  }
}